<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img
        v-if="bannerArr.length > 0"
        :src="$imgUrl + bannerArr[0].thumb"
        alt=""
      />
    </div>
    <div class="container">
      <div class="search_box">
        <div class="custom_sel">
          <el-select
            @change="changeSel"
            class="sel"
            v-model="search.session_expo"
            clearable
            :placeholder="langSet == 'cn' ? '届次选择' : 'Session Select'"
          >
            <el-option
              v-for="(item, index) in sessionList"
              :key="index"
              :value="item.value"
              >{{ item.name }}</el-option
            >
          </el-select>
        </div>
        <div class="input_box">
          <input
            class="search_value"
            v-model="search.keywords"
            type="text"
            :placeholder="
              langSet == 'cn'
                ? '搜索展商名称或展位号'
                : 'Search Exhibitor Name Or Booth Number'
            "
          />
          <img class="input_icon" src="../../assets/search.jpg" />
        </div>
        <div class="btn_box">
          <button class="custom_btn search_btn" @click="searchVal">
            {{ langSet == "cn" ? "查询" : "Search" }}
          </button>
          <button class="custom_btn reset_btn" @click="reset">
            {{ langSet == "cn" ? "重置" : "Reset" }}
          </button>
        </div>
      </div>
      <div class="ex_tips">
        {{ langSet == "cn" ? "(按首字母排序)" : "(in alphabetical order)" }}
      </div>
      <div class="ex_list" v-loading="loading" v-if="companyList.length > 0">
        <div
          class="ex_item"
          v-for="(item, index) in companyList"
          :key="index"

        >
<!--          去详情 功能隐藏 2025年11月18日14:37:59  @click="gotoDetail(item)"-->

          <div class="ex_title" v-if="item.lintel_cn || item.lintel_en">
            {{ langSet == "cn" ? item.lintel_cn : item.lintel_en }}
          </div>
          <div class="ex_title" v-else>
            {{ langSet == "cn" ? item.name_cn : item.name_en }}
          </div>
          <div class="ex_address">
            {{ langSet == "cn" ? item.address : item.address_en }}
          </div>
          <div class="ex_bottom_box">
            <div class="ex_booth">
              <img src="../../assets/location.jpg" alt="" />
              <span
                >{{ langSet == "cn" ? "展位号" : "Booth Number" }}：{{
                  item.booth_no
                }}</span
              >
            </div>
<!--            隐藏 2025年11月18日14:37:25 zfx-->
<!--            <div class="ex_detail">-->
<!--              <span>{{ langSet == "cn" ? "查看详情" : "View Details" }}</span>-->
<!--              <img class="more" src="../../assets/more.jpg" alt="" />-->
<!--              <img class="more_sel" src="../../assets/more_sel.jpg" alt="" />-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="nodata_box" v-else>
        <nodata></nodata>
      </div>

      <div class="ex_footer">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="search.page_no"
          @current-change="handleCurrentChange"
          :page-size="search.page_size"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>
  
  <script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import nodata from "../../components/nodata.vue";
import { getBanner, getCompanyList, getSessionList } from "@/api/api";
export default {
  components: { top, bottom, nodata },
  name: "exhibitorList",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet == "cn" ? this.keydata.name_cn : this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      search: {
        page_no: 1,
        page_size: 12,
        session_expo: "",
        keywords: "",
      },
      langSet: "",
      bannerArr: [],
      companyList: [],
      sessionList: [],
      total: 0,
      loading: false,
      keydata: {},
    };
  },
  created() {},
  mounted() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    console.log(menuArr, "menuArr");
    menuArr.map((item) => {
      if (item.children) {
        item.children.map((i) => {
          if (i.name_cn == "在线会刊" || i.name_en == "Online Journal") {
            this.keydata = i;
          }
        });
      }
    });

    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getSession();
  },
  methods: {
    // zhang 获取展商列表banner
    getBannerList() {
      let data = {
        class: "展商列表",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取展商列表数据
    getCompany() {
      this.loading = true;
      getCompanyList(this.search)
        .then((res) => {
          if (res.code == 1) {
            this.companyList = res.data.lists;
            this.total = res.data.count;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    // zhang 获取展商列表届次
    getSession() {
      let data = {};
      getSessionList(data)
        .then((res) => {
          if (res.code == 1) {
            this.sessionList = res.data.lists;
            this.search.session_expo = this.sessionList[0].value;
            this.getCompany();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 展商查询
    searchVal() {
      this.getCompany();
    },
    // 重置
    reset() {
      this.search.session_expo = "";
      this.search.keywords = "";
      this.search.page_no = 1;
      this.search.page_size = 12;
      this.getCompany();
    },
    // 切换分页
    handleCurrentChange(val) {
      this.search.page_no = val;
      this.getCompany();
    },
    // zhang 进去展商详情
    gotoDetail(item) {
      this.$router.push({
        path: "/exhibitorDetail",
        query: {
          company_long_id: item.company_long_id,
        },
      });
    },
    changeSel(e) {
      this.search.page_no = 1;
      this.getCompany();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.nodata_box {
  margin: 90px 0 50px;
}
.logo {
  width: 100%;
  height: 600px;
  img {
    width: 100%;
    height: 600px;
  }
}
.custom_btn {
  width: 120px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #243889;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.search_btn {
  background: #243889;
  border-radius: 12px;
  color: #ffffff;
  margin: 0 20px;
}
.reset_btn {
  background: #f7f8fa;
  color: #2c2c2e;
}
.container {
  background: #fff;
  // width: 1280px;
  margin: 50px auto 70px;
  .ex_footer {
    background: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }
  .search_box {
    display: flex;
    .custom_sel {
      width: 200px;
      position: relative;
      margin-right: 20px;
      .sel::placeholder {
        color: #000 !important;
      }
    }
    .input_box {
      position: relative;
      .input_icon {
        position: absolute;
        left: 20px;
        top: 15px;
        width: 20px;
        height: 20px;
      }
    }
    .btn_box {
      display: flex;
    }
  }
  .ex_tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 20px 0 10px;
  }
  .ex_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .ex_item {
      display: flex;
      flex-wrap: wrap;
      width: -webkit-calc((100% - 20px * 4)/ 4);
      width: calc((100% - 20px * 4) / 4);
      margin: 0 20px 20px 0;
      padding: 15px 0;
      box-sizing: border-box;
      background: rgba(171, 181, 205, 0.1) url("../../assets/ex_bg.png")
        no-repeat top;
      background-size: 60px;
      background-position-x: 80px;

      cursor: pointer;
      border: 1px solid transparent;
      .ex_title {
        width: 273px;
        height: 44px;
        line-height: 22px;
        padding: 0 15px;
        box-sizing: border-box;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #2c2c2e;
      }
      .ex_address {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #757575;
        margin-top: 5px;
        margin-bottom: 8px;
      }
      .ex_bottom_box {
        width: 100%;
        padding: 16px 15px 0;
        box-sizing: border-box;
        align-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #eeeeee;
        .ex_booth {
          display: flex;
          align-items: center;
          img {
            width: 13px;
            height: 18px;
          }
          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #2c2c2e;
            margin-left: 8px;
          }
        }
        .ex_detail {
          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #757575;
          }
          img {
            width: 7px;
            height: 10px;
            margin-left: 6px;
          }
          .more_sel {
            display: none;
          }
        }
      }
    }
    .ex_item:hover {
      border-color: #243889;
      .ex_detail {
        span {
          color: #243889;
        }
        .more {
          display: none;
        }
        .more_sel {
          display: inline-block;
        }
      }
    }
  }
  .ex_list::after {
    content: "";
    flex: auto;
  }
  .search_value {
    width: 815px;
    height: 50px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #dddddd;
    padding-left: 55px;
    box-sizing: border-box;
  }
  .search_value::placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}
@media only screen and (max-width: 1280px) {
  .ex_item {
    width: -webkit-calc((100% - 20px * 3)/ 3) !important;
    width: calc((100% - 20px * 3) / 3) !important;
    margin: 0 20px 20px 0 !important;
  }
  .search_box {
    flex-wrap: wrap;
  }
  .container .search_value {
    width: 580px;
  }
  .container .search_box .custom_sel {
    width: 200px;
  }
  .btn_box {
    margin-top: 15px !important;
    width: 100%;
  }
  .search_btn {
    margin: 0 15px 0 0px !important;
  }
}
@media only screen and (max-width: 1000px) {
  .ex_item {
    width: -webkit-calc((100% - 20px * 2)/ 2) !important;
    width: calc((100% - 20px * 2) / 2) !important;
    margin: 0 20px 20px 0 !important;
  }
  .container .search_value {
    width: 580px;
  }
  .container .search_box .custom_sel {
    width: 200px;
  }
  .search_box {
    flex-wrap: wrap;
  }
  .btn_box {
    margin-top: 15px !important;
    width: 100%;
  }
  .input_box {
    margin-top: 15px !important;
  }
  .search_btn {
    margin: 0 15px 0 0px !important;
  }
}
@media only screen and (max-width: 768px) {
  .input_box {
    margin-top: 15px !important;
  }
  .container {
    width: 95% !important;
  }
  .custom_btn {
    width: 90px !important;
    height: 36px !important;
    font-size: 14px !important;
  }
  .search_btn {
    border-radius: 6px !important;
    margin: 0 15px 0 0px !important;
  }
  .reset_btn {
    border-radius: 6px !important;
  }
  .search_value::placeholder {
    font-size: 14px !important;
  }
  .btn_box {
    margin-top: 15px !important;
    width: 100%;
    // justify-content: right;
  }
  .logo {
    width: 100%;
    height: 122px;
    margin-top: 0.88rem;
    img {
      width: 100%;
      height: 122px;
    }
  }
  .search_value {
    width: 100% !important;
    height: 46px !important;
    border-radius: 5px !important;
    padding-left: 40px !important;
  }
  .ex_item {
    width: 100% !important;
    margin: 0 0 15px !important;
  }
  .search_box {
    flex-wrap: wrap;
  }
  .custom_sel {
    width: 200px !important;
  }
  .input_box {
    width: 100% !important;
    height: 46px !important;
    border-radius: 5px !important;
  }
  .input_icon {
    width: 16px !important;
    height: 16px !important;
  }
}
</style>
  <style>
.exhibitorList_box .el-select {
  width: 165px;
  height: 50px;
}
.custom_sel .el-select .el-input__inner {
  height: 50px;
  background: #f7f8fa;
  border-radius: 12px;
  border: none;
}
.custom_sel .el-select > .el-input {
  height: 50px;
}
.exhibitorList_box .el-select .el-input .el-select__caret {
  color: #000;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #243889;
  border-radius: 4px;
  border: 1px solid #243889;
}
@media only screen and (max-width: 767px) {
  .el-input__inner {
    height: 46px !important;
    line-height: 46px !important;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    margin: 0 3px !important;
  }
}
</style>